import { render, staticRenderFns } from "./DuplicateReceipt-copy.vue?vue&type=template&id=6ee3c87c&scoped=true&"
import script from "./DuplicateReceipt-copy.vue?vue&type=script&lang=js&"
export * from "./DuplicateReceipt-copy.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateReceipt-copy.vue?vue&type=style&index=0&id=6ee3c87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee3c87c",
  null
  
)

export default component.exports